module.exports = __webpack_public_path__ + "img/thyroid.4f4a27a0.svg";